'use client'
import Link from 'next/link'
import { Box, Loader } from '@quintoandar-tokko/jopijs'
import style from './calendarButton.module.scss'
import googleIcon from './icons/googleCalendarIcon.svg'
import outlookIcon from './icons/outlookCalendarIcon.svg'
import ImageNext from '@/components/shared/ImageNext'

export default function CalendarButton ({
  children,
  icon,
  loading,
  disabled,
  href,
  className = '',
  iconPosition = 'before',
  variant = 'primary',
  size = 'medium',
  loaderSize = 20,
  ...props
}) {
  const isLink = Boolean(href)
  const classNames = `${className} ${style.button} ${loading ? style.buttonLoading : ''} ${iconPosition === 'after' ? style.buttonReverse : ''}`

  const renderIcon = () => {
    const icons = {
      google: googleIcon,
      outlook: outlookIcon,
    }

    const src = icons[icon]
    if (!src) return null

    return (
      <ImageNext
        src={src}
        alt={icon}
        width={20}
        height={20}
      />
    )
  }
  

  const content = (
    <>
      {loading && (
        <Box className={style.loader}>
          <Loader
            variant="spinner"
            style={{
              backgroundImage: "conic-gradient(#878C9B, #FFFFFF)",
              height: loaderSize,
              margin: 0,
              width: loaderSize,
            }}
          />
        </Box>
      )}

      {icon && renderIcon()}
      {children}
    </>
  )

  if (isLink) {
    return (
      <Link
        href={href}
        className={classNames}
        data-variant={variant}
        data-size={size}
        aria-disabled={loading || disabled}
        {...props}
        >
          {content}
      </Link>
    )
  }

  return (
    <Box
      as="button"
      className={classNames}
      disabled={disabled || loading}
      data-variant={variant}
      data-size={size}
      {...props}
    >
      {content}
    </Box>
  )
}
